export const RainIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="12" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M65.249 52.347c4.968 0 8.986-3.955 8.986-8.821 0-4.867-4.018-8.822-8.986-8.822a9.16 9.16 0 00-2.332.3 1.55 1.55 0 01-1.93-1.291c-.586-4.352-4.384-7.65-8.907-7.65-.106 0-.212 0-.317.004a1.55 1.55 0 01-1.566-1.22c-1.478-6.8-7.621-11.748-14.798-11.748-7.777 0-14.26 5.791-15.05 13.325a1.55 1.55 0 01-1.457 1.386c-6.605.36-11.793 5.74-11.793 12.259 0 6.776 5.59 12.278 12.497 12.278H65.25zm0-20.741c6.669 0 12.084 5.331 12.084 11.92 0 6.589-5.415 11.92-12.084 11.92H19.596C10.988 55.446 4 48.567 4 40.069c0-7.749 5.826-14.196 13.445-15.232C18.957 16.347 26.48 10 35.4 10c8.21 0 15.307 5.39 17.522 12.992 5.142.35 9.46 3.889 10.807 8.707a12.349 12.349 0 011.52-.093z"
                        fill="#717277"
                    />
                    <path
                        d="M44.317 63.797a1.55 1.55 0 00-2.19-2.19l-5.113 5.112a1.55 1.55 0 102.19 2.19l5.113-5.112zM64.975 63.797a1.55 1.55 0 00-2.191-2.19l-5.112 5.112a1.55 1.55 0 102.19 2.19l5.113-5.112zM23.66 63.797a1.55 1.55 0 00-2.191-2.19l-5.113 5.112a1.55 1.55 0 002.192 2.19l5.112-5.112z"
                        fill="#9ADAFF"
                    />
                </g>
            </g>
        </g>
    </svg>
);
